import { render, staticRenderFns } from "./taskSortBy.vue?vue&type=template&id=7e3b1b48&scoped=true"
import script from "./taskSortBy.vue?vue&type=script&lang=js"
export * from "./taskSortBy.vue?vue&type=script&lang=js"
import style0 from "./taskSortBy.vue?vue&type=style&index=0&id=7e3b1b48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3b1b48",
  null
  
)

export default component.exports